import React, { Fragment } from 'react';
import { useDispatch } from 'react-redux';
import { addArticleItem } from '../Actions/Compare.action';

export const CompareCloseButton = ({ closeToast }) => (
  <div className="toastify__close-button">
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2zm0 1.5a8.5 8.5 0 1 0 0 17 8.5 8.5 0 0 0 0-17zm3.446 4.897.084.073a.75.75 0 0 1 .073.976l-.073.084L13.061 12l2.47 2.47a.75.75 0 0 1 .072.976l-.073.084a.75.75 0 0 1-.976.073l-.084-.073L12 13.061l-2.47 2.47a.75.75 0 0 1-.976.072l-.084-.073a.75.75 0 0 1-.073-.976l.073-.084L10.939 12l-2.47-2.47a.75.75 0 0 1-.072-.976l.073-.084a.75.75 0 0 1 .976-.073l.084.073L12 10.939l2.47-2.47a.75.75 0 0 1 .976-.072z"
        fill="#1D1D1D"
      />
    </svg>
  </div>
);

const CompareButton = ({ label, articleNumber }) => {
  const dispatch = useDispatch();

  const addToCompare = (article) => {
    dispatch(addArticleItem(article));
  };

  return (
    <Fragment>
      {articleNumber ? (
        <button
          className="compare-button"
          onClick={(e) => {
            e.preventDefault();
            addToCompare({
              label,
              articleNumber,
            });
          }}
        >
          <i className="compare-button__icon"></i>
          <span className="compare-button__label">{label}</span>
        </button>
      ) : (
        <button
          className="compare-button"
          onClick={(e) => {
            e.preventDefault();
            addToCompare({
              label,
              articleNumber,
            });
          }}
        >
          <i className="compare-button__icon"></i>
          <span className="compare-button__label">{label}</span>
        </button>
      )}
    </Fragment>
  );
};

export default CompareButton;
